<template>
  <div class="mt-10">
    <md-card>
      <md-card-expand>
        <md-card-actions md-alignment="space-between">
          <md-card-expand-trigger>
            <md-button class="expand-button-size"><strong @click="toggle('feedback')">Feedback <span>({{feedbacks.length}})</span></strong></md-button>
          </md-card-expand-trigger>
        </md-card-actions>
        <md-card-expand-content>
          <md-card-content class="feedback-section scrollable" v-show="opened.includes('feedback')">
          	<md-table class="feedback-table" v-if="feedbacks.length">
          	<md-table-row class="feedback-activity">
          		<md-table-head class="card-header">Name</md-table-head>
          		<md-table-head class="card-header">Email</md-table-head>
          		<md-table-head class="card-header">Type</md-table-head>
          		<md-table-head class="card-header">Received</md-table-head>
          		<md-table-head class="card-header">Rating</md-table-head>
          		<md-table-head class="card-header">Feedback</md-table-head>
          	</md-table-row>
          	<template v-for="feedback in sortFeedbacks">
            	<md-table-row class="feedback-activity" v-if="feedback" v-bind:key="feedback._id">
              		<md-table-cell v-if="feedback.name"><span class="display-link" @click="goToProfile(feedback.memberId)">{{feedback.name}}</span></md-table-cell>
              		<md-table-cell v-else>N/A</md-table-cell>
              		<md-table-cell v-if="feedback.email">{{feedback.email}}</md-table-cell>
              		<md-table-cell v-else>N/A</md-table-cell>
              		<md-table-cell v-if="feedback.type">{{feedback.type}}</md-table-cell>
              		<md-table-cell v-else>N/A</md-table-cell>
              		<md-table-cell v-if="feedback.received">{{feedback.received | momentDate}}</md-table-cell>
              		<md-table-cell v-else>N/A</md-table-cell>
              		<md-table-cell v-if="feedback.rating">{{feedback.rating}}</md-table-cell>
              		<md-table-cell v-else>N/A</md-table-cell>
              		<md-table-cell class="feedback-paragraph" v-if="feedback.feedback">{{feedback.feedback}}</md-table-cell>
              		<md-table-cell v-else>N/A</md-table-cell>
            	</md-table-row>
            </template>
            </md-table>
            <!--<p class="m-left-5" v-if="!feedbacks.length"><small>No Feedback</small></p>-->
          </md-card-content>
        </md-card-expand-content>
      </md-card-expand>
    </md-card>
  </div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
export default {
  name: "AskFeedback",
  props: ["ask", "feedbacks"],
  data() {
  	return {
  		api: new API(),
  		opened: []
  	}
  },
  computed: {
    sortFeedbacks: function() {
      if (this.feedbacks) {
      let feedbacks = this.feedbacks.slice()
        return feedbacks.sort((a, b) => {
          return a.received < b.received ? 1 : -1;
        });
      }
    }
  },
  methods: {
  	currentTags: function(activity) {
    	if (activity.details) {
    		return activity.details.replace(/,/g, ', ');
    	}
    },
    goToProfile: function(memberID) {
      let route = this.$router.resolve({path: `/members/${memberID}`});
      window.open(route.href, '_blank');
    },
    toggle(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
      	//this.opened.splice(index, 1)
      } else {
      	this.opened.push(id)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AskFeedback.vue